let BASE_URL = window["env"]["base_url"]
let BOT_BASE_URL = window["env"]["bot_base_url"]
let BOT_BASE_URL_TEST = window["env"]["bot_base_url_test"]

export const environment = {
  production: window["env"]["production"] === 'False',
  ALLOW_TESTVA_DEPLOYMENT: !(window["env"]["ALLOW_TESTVA_DEPLOYMENT"] === 'False') ,
  identity_service_api : BASE_URL + "/identity_service/",
  va_service_api : BASE_URL +  "/project_service/",
  kb_service_api : BASE_URL + "/kb_service/",
  socket_service_api : BASE_URL+"/",
  communication_service_api: BASE_URL +  "/communication_service/",
  va_launcher_api : BASE_URL + "/va_launcher_service/",
  image_parser_service_api : BASE_URL + "/image_parser_service/",
  ontology_service_api : BASE_URL + "/kb_service/ontology_interface/",
  va_training_api: BASE_URL + "/training_service/",
  profile_service_api: BASE_URL + "/kb_service/profiling_interface/",
  multi_topic_api: BASE_URL + "/kb_service/multitopic_interface/",
  //va_training_api: "http://127.0.0.1:7007/",
  kb_analytics_api: BASE_URL + "/analytics_service/kb/",
  analytics_api: BASE_URL + "/analytics_service/",
  launched_api:  BOT_BASE_URL,
  launched_test_api: BOT_BASE_URL_TEST,
  flow_api: BASE_URL + "/flow_service/",
  chat_takeover_api : BASE_URL + "/integration_services/chat_takeover/",
  base_url: BASE_URL + "/",
  integrations_url: BASE_URL + "/testbots/integration/",
  doc_url: BASE_URL + "/docs",
  cira_library_url: BASE_URL + "/",
  community_dashboard_url: BASE_URL + "/community-dashboard/community-dashboard/",
  auto_utterance_url: BASE_URL + "/utterance_generator/utterance_generator/",
  knowledge_repo_service: BASE_URL + '/knowledge_service/',
  webcomponent_prod_base_url: BOT_BASE_URL +'va/',
  webcomponent_base_url: BOT_BASE_URL_TEST +'va/',
  base_dashboard_lite_url: BASE_URL +'/dashboard-lite/',
  base_dashboard_url: BASE_URL +'/dashboard/',
  package_library_service: window["env"]["package_library_service"] + '/project_service/package_library',
  sso_redirect_url: '',
  rest_heart_service: BASE_URL +'/download_va/',
  content_training_api: BASE_URL + "/content_search_service/",
  content_search_api: BOT_BASE_URL_TEST + "content_search/",
  que_gen_service: BASE_URL + "/que_gen_service/",
  generateque_service: BASE_URL +  "/generateque_service"
};
